import { render, staticRenderFns } from "./BranchCreate.vue?vue&type=template&id=70ffade6&"
import script from "./BranchCreate.vue?vue&type=script&lang=js&"
export * from "./BranchCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports